
<template>
  <el-dialog
    title="导入技术服务"
    :visible.sync="value"
    width="80%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="detailForm"
      :rules="rules"
      :model="model"
    >
      <el-table :data="model.uploadData">
        <!-- 技术名称 -->

        <el-table-column label="技术名称" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jiShuMingCheng'"
              :rules="rules.jiShuMingCheng"
            >
              <el-input
                v-model="scope.row.jiShuMingCheng"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 学科领域 -->

        <el-table-column label="学科领域" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.xueKeLingYuDictKey'"
              :rules="rules.xueKeLingYuDictKey"
            >
              <el-select
                v-model="scope.row.xueKeLingYuDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D69')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 类型 -->

        <el-table-column label="类型" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.leiXingDictKey'"
              :rules="rules.leiXingDictKey"
            >
              <el-select
                v-model="scope.row.leiXingDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D70')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 分类 -->

        <el-table-column label="分类" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.fenLeiDictKey'"
              :rules="rules.fenLeiDictKey"
            >
              <el-select
                v-model="scope.row.fenLeiDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D71')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 类别 -->

        <el-table-column label="类别" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.leiBieDictKey'"
              :rules="rules.leiBieDictKey"
            >
              <el-select
                v-model="scope.row.leiBieDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D72')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 特色 -->

        <el-table-column label="特色" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.teSe'"
              :rules="rules.teSe"
            >
              <el-input
                v-model="scope.row.teSe"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 简介 -->

        <el-table-column label="简介" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jianJie'"
              :rules="rules.jianJie"
            >
              <el-input
                v-model="scope.row.jianJie"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              <el-button
                type="text"
                size="small"
                @click.stop="handleRowDel( scope.row,scope.$index)"
              >
                删除
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleUploadData('detailForm')"
      >保  存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'

export default {
  components: { },
  props: {
    value: Boolean,
    uploadData: { type: Array, default: null }},
  data() {
    return {
      model: { uploadData: {}},
      allComboxData: [],
      formCode: 'zy03',
      rules: {
      }
    }
  },
  watch: {
    uploadData: function() {
      this.model.uploadData = this.uploadData
    }
  },
  mounted: function() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D69;D70;D71;D72').then(res => {
      this.allComboxData = res.data.result
    })
    this.model.uploadData = this.uploadData
  },
  methods: {
    handleOpenDailog() {},
    handleCloseDailog() {
      this.$emit('input', false)
    },
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 保存数据
    handleUploadData() {
      this.$refs['detailForm'].validate(valid => {
        if (valid) {
          const url = '/api/services/app/zy03/ImportCreatezy03'
          pathReq.postForm(url,
            { entityList: this.model.uploadData }
          ).then(() => {
            this.$message.success('导入成功')
            this.$emit('input', false)
            this.$emit('save-success')
          })
        }
      })
    },
    handleRowDel(row, index) {
      this.model.uploadData.splice(index, 1)
    }
  }
}
</script>
